import { Stack } from '@chakra-ui/react';
import { Portal } from 'api/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AiOutlineForm } from 'react-icons/ai';

import { DataTable } from '../../components/Table/DataTable';
import useDsbFormsQuery from '../../hooks/useDsbFormsQuery';
import useMakesQuery from '../../hooks/useMakesQuery';
import { ContentCard } from '../../layout/ContentCard';

const MakeCard = () => {
  const { t } = useTranslation();

  const makesQuery = useMakesQuery();
  const dsbFormsQuery = useDsbFormsQuery();

  const columns = useMemo(
    () => [
      {
        Header: t('pages:config_makes.table.columns.name'),
        accessor: 'name',
      },
      {
        Header: t('forms:slug.label'),
        accessor: 'slug',
      },
      {
        Header: t('pages:config_makes.table.columns.portal'),
        accessor: (row: { portal: Portal }) => row?.portal?.url ?? '-',
      },
      {
        Header: t('pages:config_makes.table.columns.max_age_in_days'),
        accessor: 'max_age_in_days',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dsbFormsQuery.data],
  );

  return (
    <ContentCard
      isLoading={makesQuery.isLoading || dsbFormsQuery.isLoading || makesQuery.isFetching || dsbFormsQuery.isFetching}
      icon={<AiOutlineForm size={'40px'} />}
      minH="fit-content"
      header={t('pages:config_makes.table.header')}
      contentDescription={t('pages:config_makes.table.description')}
      data-test-id="make-card"
    >
      <Stack direction={['column', 'row']} w={'100%'}>
        <Stack direction="column" w={'100%'}>
          <DataTable
            data-test-id="makes-table"
            data={makesQuery.data || []}
            hasFilters={false}
            columns={columns}
            isMoreThenOnePage={false}
            hasSearchInput={undefined as any}
          />
        </Stack>
      </Stack>
    </ContentCard>
  );
};

export default MakeCard;
